// Helpers and default JSON validator for CodeBlock linting
export const extractJsonErrorPosition = (msg?: string): number | null => {
  if (!msg) {
    return null;
  }
  // Common V8 message: "Unexpected token ... in JSON at position 123"
  let m = msg.match(/at position (\d+)/i);
  if (m) {
    return parseInt(m[1], 10);
  }
  // Try a more generic `position N` match
  m = msg.match(/position (\d+)/i);
  if (m) {
    return parseInt(m[1], 10);
  }
  return null;
};

export const getLineBounds = (doc: string, index: number) => {
  const start = Math.max(0, doc.lastIndexOf("\n", index - 1) + 1);
  let end = doc.indexOf("\n", index);
  if (end === -1) {
    end = doc.length;
  }
  return { from: start, to: end };
};

export type Diagnostic = {
  from: number;
  to: number;
  message: string;
  severity?: "error" | "warning";
};

export const defaultJsonValidate = (code: string): Diagnostic[] => {
  try {
    JSON.parse(code);
    return [];
  } catch (e: unknown) {
    if (e instanceof SyntaxError) {
      const msg = e?.message ? String(e.message) : String(e);
      const pos = extractJsonErrorPosition(msg);
      if (pos !== null && pos >= 0 && pos <= code.length) {
        const bounds = getLineBounds(code, pos);
        return [
          {
            from: bounds.from,
            to: bounds.to,
            message: msg,
            severity: "error",
          },
        ];
      }
      return [
        {
          from: 0,
          to: code.length,
          message: msg,
          severity: "error",
        },
      ];
    } else {
      const msg = String(e);
      return [
        {
          from: 0,
          to: code.length,
          message: msg,
          severity: "error",
        },
      ];
    }
  }
};

export default defaultJsonValidate;
